import React from "react";
import { useLocation } from "react-router-dom";

const Footer = () => {
	const { pathname } = useLocation();

	return (
		<div
			className={`w-full ${
				pathname === "/about" ? "" : "lg:fixed lg:bottom-0"
			} p-5 text-center -z-1`}>
			<span className="text-green-800 text-md font-bold cursor-pointer">
				⚡ by AlphaChino &copy; 2024
			</span>
		</div>
	);
};

export default Footer;
